import React, { useEffect, useState } from "react"
import styled from "styled-components"

import StatsCard from "./statsCard/StatsCard"

import { fetchData, removeData } from "../../store/action"
import { useDispatch, useSelector } from "react-redux"
import { bidwinStats } from "../../dummyData"

const StatsContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  box-sizing: border-box;
  justify-content: space-between;
`

const StatsConatiner = ({ theme }) => {
  const dispatch = useDispatch()
  const [stats, setStats] = useState([])
  let uniqueId
  useEffect(
    () => {
      dispatch(
        fetchData({
          uniqueId,
          method: "GET",
          uri: `/stats?operatorId=ind`,
          onSuccess: (res) => {
            console.log("stats data", res)
            setStats(res.statsList)
            // setTimeout((_) => {
            //   this.showPopup()
            // }, 2000)
            // saveData(res)
          },
        })
      )
      return () => {
        dispatch(removeData({ uniqueId }))
      }
    },
    [dispatch]
  )

  return (
    <StatsContainer>
      {/* <StatsRow style={{ paddingBottom: 0 }}>
            <StatsCard stats='100K' title='Total Users' />
            <StatsCard stats='70' title='Countries' />
          </StatsRow>
          <StatsRow>
            <StatsCard stats='2K' title='Bids Won' />
            <StatsCard stats='$40K' title='Prizes Won' />
          </StatsRow> */}
      {stats.map((stat, index) => (
        <StatsCard
          key={index}
          stats={stat.stats}
          title={stat.parameter}
          theme={theme}
        />
      ))}
    </StatsContainer>
  )
}

export default StatsConatiner



// WEBPACK FOOTER //
// ./src/components/Stats/StatsConatiner.js